import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { PricingRuleResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A facility's pricing rules. The court sheet derives its per-slot ESTIMATE from
 * the per_hour court_reservation rule via `slotEstimate` (the price firewall) —
 * this hook only fetches; it does no price math.
 */
export function usePricingRules(facilityId: string | undefined) {
  return useQuery<PricingRuleResponse[]>({
    queryKey: queryKeys.booking.pricing(facilityId ?? ""),
    queryFn: () => facilityApi.listPricingRules(facilityId as string),
    enabled: Boolean(facilityId),
  });
}
